import { useEffect } from "react";
import NotificationsModel from "../../Models/Notifications/Notifications.Model";

export default function NotificationView() {
    const { allNotifications } = NotificationsModel.useState()
    useEffect(() => {
        NotificationsModel.loadNotifications(true, false);

    }, []);

    return <>
        <h1>Notifications</h1>
        <div className="flex flex-col gap-2">
            {allNotifications?.map((notification) => (
                <div key={notification.id} className="p-4 border rounded-md bg-white shadow-sm">
                    <h2 className="text-lg font-semibold">{notification.type}</h2>
                    <p className="text-sm text-gray-600">{notification.id}</p>

                </div>
            ))}
        </div>
    </>


}